"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[8055],{

/***/ 58055:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var images__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89041);
/* harmony import */ var styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53301);
/* harmony import */ var utils_font_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5581);
/* harmony import */ var utils_turbolinks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59987);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4159);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(utils_general__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_permissions_limits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47459);
/* harmony import */ var utils_permissions_permissions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27839);
/* harmony import */ var utils_prototype__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26432);
/* harmony import */ var utils_prototype__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(utils_prototype__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_storage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90048);
/* harmony import */ var utils_storage__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(utils_storage__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var utils_blazy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97970);
/* harmony import */ var utils_blazy__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(utils_blazy__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var utils_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50690);
/* harmony import */ var utils_bootstrap__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(utils_bootstrap__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var utils_bs_dropdown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17079);
/* harmony import */ var utils_bs_dropdown__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(utils_bs_dropdown__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var utils_current_user__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4042);
/* harmony import */ var utils_current_user__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(utils_current_user__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69705);
/* harmony import */ var utils_form_clear__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92030);
/* harmony import */ var utils_form_clear__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(utils_form_clear__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var utils_icontains__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46655);
/* harmony import */ var utils_icontains__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(utils_icontains__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var utils_lazy__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51003);
/* harmony import */ var utils_media_query__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(28925);
/* harmony import */ var utils_scroll_to__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15737);
/* harmony import */ var utils_scroll_to__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(utils_scroll_to__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var utils_statements__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(92189);
/* harmony import */ var utils_thor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(51320);
/* harmony import */ var utils_toastr__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16111);
/* harmony import */ var utils_toggle_input__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33927);
/* harmony import */ var utils_toggle_input__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(utils_toggle_input__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var utils_turbolinks_form__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(72476);
/* harmony import */ var utils_turbolinks_form__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(utils_turbolinks_form__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var utils_vendor_manager__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(53546);
/* harmony import */ var utils_vendor_manager__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(utils_vendor_manager__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var components_ajax_sidebar__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(43456);
/* harmony import */ var components_billing_billing_top_bar__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(41705);
/* harmony import */ var components_breadcrumb__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(87665);
/* harmony import */ var components_campaigns_interventions_top_bar__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(94471);
/* harmony import */ var components_cookies_agreement__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8150);
/* harmony import */ var components_dev_loading__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(18312);
/* harmony import */ var components_footer__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(35423);
/* harmony import */ var components_google_one_tap_auth__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(95890);
/* harmony import */ var components_header__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(95118);
/* harmony import */ var components_intervention_bottom_bar__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(40370);
/* harmony import */ var components_lesson_freemium_alert__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(67566);
/* harmony import */ var components_lesson_freemium_banner__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(35441);
/* harmony import */ var components_lesson_freemium_sign_in__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(39380);
/* harmony import */ var components_logo__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(99406);
/* harmony import */ var components_menu__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(89506);
/* harmony import */ var components_menu_old__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(31900);
/* harmony import */ var components_modals_configure_account__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(12600);
/* harmony import */ var components_modals_not_premium_user_modal__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56797);
/* harmony import */ var components_modals_pay_wall_modal__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(23639);
/* harmony import */ var components_modals_setup__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(49689);
/* harmony import */ var components_modals_setup_opportunity__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(1383);
/* harmony import */ var components_new_menu__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(84546);
/* harmony import */ var components_notification_bar__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(81790);
/* harmony import */ var components_outdated_browser__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(48023);
/* harmony import */ var components_pagination__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(6746);
/* harmony import */ var components_payment_error_topbar__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(98290);
/* harmony import */ var components_share__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(24246);
/* harmony import */ var components_smart_banner__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(73944);
/* harmony import */ var components_sticky_cta_menu__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(20592);
/* harmony import */ var components_subscription_expiration_modal__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(50058);
/* harmony import */ var components_trial_modal__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(99537);
/* harmony import */ var components_trial_top_bar__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(87412);
/* harmony import */ var components_modals_lifelong_upgrade_modal__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(24955);
/* harmony import */ var utils_serialize_object__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(49539);
/* harmony import */ var utils_serialize_object__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(utils_serialize_object__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var utils_trackers__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(87586);
/* harmony import */ var utils_trackers_user__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(4687);
/* harmony import */ var utils_trackers_zaraz__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(19394);
/* harmony import */ var _odin_iterable_messages__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(72683);
/* harmony import */ var utils_lazy_scripts__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(90521);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




/* Utils */ 




// import 'utils/input_mask';



 // TODO: Refact - Import in each module and remove from application.js












/* Global Components */ 





















// import 'components/new_menu_old'; // logged in
 // logged in


 // logged in
 // logged in





/* External Services */ 






if ((self || window).RAILS_ENV === 'development') {
    const hideLoading = ()=>{
        const loading = document.getElementById('dev-loading');
        if (loading) {
            loading.remove();
        }
    };
    document.addEventListener('DOMContentLoaded', ()=>{
        hideLoading();
        document.addEventListener('turbolinks:render', ()=>hideLoading());
    });
}
const trackIterablePageView = ()=>{
    UserTracker.emit('event', {
        eventName: 'pageVisited',
        data: {
            pageName: window.location.pathname + window.location.search,
            hostname: window.location.hostname,
            pathname: window.location.pathname,
            search: window.location.search
        },
        only: [
            'iterable'
        ]
    });
};
const trackEventMenu = ()=>{
    const $container = window.jQuery('#experimentMenu');
    const eventData = $container.data('event') || {};
    const isSendEvent = (eventData == null ? void 0 : eventData.active) && (eventData == null ? void 0 : eventData.zaraz_send_event) && (eventData == null ? void 0 : eventData.event_props);
    if ($container && isSendEvent) {
        utils_trackers_zaraz__WEBPACK_IMPORTED_MODULE_61__/* ["default"].set */ .Z.set('show_experiment', 'true', {
            scope: 'persist'
        });
        utils_trackers_zaraz__WEBPACK_IMPORTED_MODULE_61__/* ["default"].track */ .Z.track(eventData.zaraz_event, eventData.event_props);
    }
};
const trackTurbolinksRender = ()=>{
    utils_trackers_zaraz__WEBPACK_IMPORTED_MODULE_61__/* ["default"].track */ .Z.track('turbolinks-loaded');
};
requestIdleCallback(/*#__PURE__*/ _async_to_generator(function*() {
    (0,utils_lazy_scripts__WEBPACK_IMPORTED_MODULE_62__/* .loadLazyScripts */ .a)();
    yield (0,_odin_iterable_messages__WEBPACK_IMPORTED_MODULE_63__/* .initIterableMessages */ .b)({
        userId: gon.iterable_user.id,
        userEmail: gon.iterable_user.email,
        userToken: gon.websocket_worker_api_token
    });
    trackIterablePageView();
    trackEventMenu();
    trackTurbolinksRender();
    // callback
    const params = new URLSearchParams(window.location.search);
    if (params.get('from_omniauth') && params.get('provider')) {
        window.postMessage({
            success: true
        }, window.location.origin);
    }
    document.addEventListener('turbolinks:render', ()=>{
        trackIterablePageView();
        trackEventMenu();
        trackTurbolinksRender();
    });
    if (window.currentUser) {
        Promise.all(/* import() */[__webpack_require__.e(7505), __webpack_require__.e(4028)]).then(__webpack_require__.bind(__webpack_require__, 44028)).then(/*#__PURE__*/ _async_to_generator(function*(FirebaseMessagingService) {
            FirebaseMessagingService.default.load();
        }));
    }
}));


/***/ })

}]);